import type { FC } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import type { MomentFormMoment } from "../../../moment/types/moment-form-moment";
import { AdditionalRecipients } from "../../../recipients/components/additional-recipients";
import { useRecipientsForChannel } from "../../../recipients/hooks/use-recipients-for-channel";
import { SegmentForm } from "../segment-form";
import type { ToFormProps } from "./types";

type NotifyFormProps = ToFormProps & {
  showSegmentHeading?: boolean;
  segmentLabel?: string;
  segmentPlaceholder?: string;
};

export const NotifyForm: FC<NotifyFormProps> = ({
  formDisabled,
  restrictedSegments,
  continueClicked,
  showSegmentHeading = true,
  segmentLabel,
  segmentPlaceholder,
}) => {
  const {
    control,
    getValues,
    formState: { submitCount },
  } = useFormContext<MomentFormMoment>();

  useWatch({ control, name: ["channel"] });
  const [selectedChannel] = getValues(["channel"]);

  const loader = useRecipientsForChannel(selectedChannel, false);

  return (
    <>
      <Controller
        name="additional_recipients"
        control={control}
        render={({ field, fieldState }) => (
          <AdditionalRecipients
            value={field.value}
            channel={selectedChannel}
            onChange={field.onChange}
            disabled={formDisabled}
            error={fieldState.error?.message}
            recipientsLoader={loader}
          />
        )}
      />
      {showSegmentHeading && <h3>Who should we notify them about?</h3>}
      <SegmentForm
        connectionCategories={[]}
        disabled={formDisabled}
        showValidationErrors={continueClicked || submitCount > 0}
        restrictedSegments={restrictedSegments}
        segmentLabel={segmentLabel}
        segmentPlaceholder={segmentPlaceholder}
      />
    </>
  );
};
